"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _taggedTemplateLiteral = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  padding-right: 16px;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  padding-left: 16px;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  font-size: 14px;\n\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n  height: 100%;\n\n  ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n          margin-left: 32px;\n          "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n            margin-left: 32px;\n          "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n        padding: 0 ", "px;\n\n        ", "\n\n        ", "\n      "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n            margin-left: 32px;\n            "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n              margin-left: 32px;\n            "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n          ", "\n          padding: 0 ", "px;\n\n          ", "\n\n          ", "\n        "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        ", "\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n      pointer-events: none;\n\n      &:focus,\n      &:focus-within {\n        border-color: ", ";\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      background-position: 4% 14px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border: ", " ", ";\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-position: 96% 14px;\n      &:focus,\n      &:focus-within {\n        border: 2px solid ", ";\n        box-shadow: none;\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      background-position: 4% 14px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border: ", " ", ";\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-position: 96% 14px;\n      &:focus,\n      &:focus-within {\n        border: 2px solid ", ";\n        box-shadow: none;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      height: 72px;\n      font-size: 32px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      height: 34px;\n      font-size: 14px;\n      padding: ", "px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 10px;\n\n  margin: ", "px 0 ", "px;\n\n  height: 48px;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 500;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  background-color: ", ";\n  color: ", ";\n\n  box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.1),\n    inset 0px 1px 2px rgba(0, 0, 0, 0.1);\n  -moz-appearance: textfield;\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus,\n  &:focus-within {\n    border: 2px solid ", ";\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2),\n      0px 0px 6px rgba(52, 133, 254, 0.8);\n  }\n\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  background: none;\n  border: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightContainer = exports.LeftContainer = exports.StyledContainer = exports.InputStyle = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var types_1 = __importDefault(require("./types"));

var styled_1 = __importDefault(require("../CheckboxV2/styled"));

var styled_2 = __importDefault(require("../RadioV2/styled"));

var inputError_svg_1 = __importDefault(require("../../static/inputError.svg"));

var inputValid_svg_1 = __importDefault(require("../../static/inputValid.svg"));

var reset = styled_components_1.css(_templateObject());

var baseStyles = function baseStyles(props) {
  var theme = props.theme,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$width = props.width,
      width = _props$width === void 0 ? undefined : _props$width,
      _props$error = props.error,
      error = _props$error === void 0 ? "" : _props$error,
      _props$size = props.size,
      size = _props$size === void 0 ? "default" : _props$size,
      _props$valid = props.valid,
      valid = _props$valid === void 0 ? false : _props$valid,
      _props$rightItem = props.rightItem,
      rightItem = _props$rightItem === void 0 ? undefined : _props$rightItem;
  var border = theme.border,
      spacing = theme.spacing,
      palette = theme.palette;
  return styled_components_1.css(_templateObject2(), spacing.unit * 2, spacing.unit, size === "small" && styled_components_1.css(_templateObject3(), theme.spacing.unit), size === "large" && styled_components_1.css(_templateObject4()), width && styled_components_1.css(_templateObject5(), width.toString()), bitcoincom_pkg_theme_1.colors.solid.bgGrey, palette.text["default"], bitcoincom_pkg_theme_1.colors.solid.ghost, bitcoincom_pkg_theme_1.colors.solid.primaryBlue, error && styled_components_1.css(_templateObject6(), border.solid["default"], bitcoincom_pkg_theme_1.colors.solid.primaryRed, inputError_svg_1["default"], bitcoincom_pkg_theme_1.colors.solid.primaryRed), error && rightItem && styled_components_1.css(_templateObject7()), valid && styled_components_1.css(_templateObject8(), border.solid["default"], bitcoincom_pkg_theme_1.colors.solid.primaryGreen, inputValid_svg_1["default"], bitcoincom_pkg_theme_1.colors.solid.primaryGreen), valid && rightItem && styled_components_1.css(_templateObject9()), disabled && styled_components_1.css(_templateObject10(), bitcoincom_pkg_theme_1.colors.solid.mystic, bitcoincom_pkg_theme_1.colors.solid.ghostLight, bitcoincom_pkg_theme_1.colors.solid.ghostLight, bitcoincom_pkg_theme_1.colors.solid.ghostLight));
};

var typeStyles = function typeStyles(props) {
  var type = props.type,
      theme = props.theme,
      _props$error2 = props.error,
      error = _props$error2 === void 0 ? "" : _props$error2,
      _props$valid2 = props.valid,
      valid = _props$valid2 === void 0 ? false : _props$valid2,
      _props$rightItem2 = props.rightItem,
      rightItem = _props$rightItem2 === void 0 ? undefined : _props$rightItem2,
      label = props.label;
  var spacing = theme.spacing;

  switch (type) {
    case types_1["default"].Checkbox:
      return styled_components_1.css(_templateObject11(), reset, styled_1["default"](props));

    case types_1["default"].Radio:
      return styled_components_1.css(_templateObject12(), styled_2["default"](props));

    default:
      if ((type === "text" || type === "email") && !label) {
        return styled_components_1.css(_templateObject13(), baseStyles(props), spacing.unit * 2, error && rightItem && styled_components_1.css(_templateObject14()), valid && rightItem && styled_components_1.css(_templateObject15()));
      }

      return styled_components_1.css(_templateObject16(), spacing.unit * 2, error && rightItem && styled_components_1.css(_templateObject17()), valid && rightItem && styled_components_1.css(_templateObject18()));
  }
};

exports.InputStyle = styled_components_1["default"].input(_templateObject19(), reset, function (props) {
  return typeStyles(props);
});
exports.StyledContainer = styled_components_1["default"].div(_templateObject20(), function (props) {
  return baseStyles(props);
});
exports.LeftContainer = styled_components_1["default"].div(_templateObject21());
exports.RightContainer = styled_components_1["default"].div(_templateObject22());